/** 菜单 **/
/** 会员中心 - 首页 **/
export const USER_CENTER_URL = "/user-center/index"; // 必须+index，否则会影响当前菜单高亮
/** 会员中心 - 搜索（大搜） **/
export const USER_CENTER_SEARCH_URL = "/user-center/search";
/** 老大搜 **/
export const OLD_USER_CENTER_SEARCH_URL = process.env.VUE_APP_OLD_SEARCH_URL + "/index.html";

/** 找商机 **/
export const BUSINESS_OPPORTUNITY_URL = "/business-opportunity";
/** 找商机 - 采购意向 **/
export const BUSINESS_OPPORTUNITY_PURCHASE_INTENTION_URL = "/business-opportunity/purchase-intention";
/** 找商机 - 标讯 **/
export const BUSINESS_OPPORTUNITY_BIDDING_INFO_URL = "/business-opportunity/bidding-info";
/** 找商机 - 拟在建 **/
export const BUSINESS_OPPORTUNITY_CONSTR_PROJECT_URL = "/business-opportunity/constr-project";
/** 找商机 - 审批项目 **/
export const BUSINESS_OPPORTUNITY_EXAMINE_PROJECT_URL = "/business-opportunity/examine-project";

// 订阅中心
/** 订阅中心 **/
export const SUBSCRIBE_CENTER_URL = "/subscribe-center";
/** 订阅中心 - 新增订阅 **/
export const SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_URL = "/subscribe-center/subscribe-create";
/** 订阅中心 - 新增订阅 - 标讯订阅器创建**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_BIDDING_INFO_URL = "/subscribe-center/subscribe-create/bidding-info";

/** 订阅中心 - 新增订阅 - 拟在建订阅器创建**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_CONSTR_PROJECT_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_WillBuild.html";
/** 订阅中心 - 新增订阅 - 审批订阅器创建**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_EXAMINE_PROJECT_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_Approval.html";
/** 订阅中心 - 新增订阅 - 意向采购订阅器创建**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_PURCHASE_INTENTION_URL =
  "/subscribe-center/subscribe-create/purchase-intention";
/** 订阅中心 - 订阅信息 **/
export const SUBSCRIBE_CENTER_SUBSCRIBE_INFO_URL = "/subscribe-center/subscribe-info";
/** 订阅中心 - 订阅信息 - 标讯 **/
export const SUBSCRIBE_CENTER_SUBSCRIBE_INFO_BIDDING_INFO_URL = "/subscribe-center/subscribe-info/bidding-info";
/** 订阅中心 - 订阅信息 - 拟建**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_INFO_CONSTR_PROJECT_URL = "/subscribe-center/subscribe-info/constr-project";
/** 订阅中心 - 订阅信息 - 审批**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_INFO_EXAMINE_PROJECT_URL = "/subscribe-center/subscribe-info/examine-project";
/** 订阅中心 - 订阅信息 - 采购意向**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_INFO_PURCHASE_INTENTION_URL =
  "/subscribe-center/subscribe-info/purchase-intention";
/** 老订阅信息 **/
export const OLD_SUBSCRIBE_CENTER_SUBSCRIBE_INFO_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Information.html";

/** 订阅中心 - 订阅管理 **/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL = "/subscribe-center/subscribe-manage";
/** 订阅中心 - 订阅管理 - 标讯订阅器配置**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_BIDDING_INFO_URL = "/subscribe-center/subscribe-manage/bidding-info";
/** 订阅中心 - 订阅管理 - 标讯订阅器配置（智能） **/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_SMART_BIDDING_INFO_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_Mind.html";
/** 订阅中心 - 订阅管理 - 拟在建项目订阅器配置**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_CONSTR_PROJECT_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_WillBuild.html";
/** 订阅中心 - 订阅管理 - 审批项目订阅器配置**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_EXAMINE_PROJECT_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting_Approval.html";
/** 订阅中心 - 订阅管理 - 意向采购订阅器配置**/
export const SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_PURCHASE_INTENTION_URL =
  "/subscribe-center/subscribe-manage/purchase-intention";
/** 老订阅管理 **/
export const OLD_SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subscriptionCenter_Setting.html";

// 我的关注
export const MY_COLLECTION_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_Collection.html";
export const MY_FOLLOW_BIDDING_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_followBidding.html";
export const MY_FOLLOW_PROJECT_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_followProject.html";
export const MY_ACCOUNT_PROJECT_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_accountProject.html";
export const MY_GET_BROWSES_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_getBrowses.html";
export const MY_GET_EXPORT_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_getExport.html";

// 企业管理
export const ENTERPRISE_ACCOUNT_MANAGE_TOTAL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/enterManage_Total.html";
export const ENTERPRISE_MANAGE_SUB_ACCOUNT = "/enterprise-manage/sub-account";
export const ENTERPRISE_ACCOUNT_MANAGE_SMART_MANAGE = process.env.VUE_APP_OLD_USER_CENTER_URL + "/corporateSpace.html";

// VIP服务
export const VIP_MATCH_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/vip_Match.html";
export const VIP_ENTRUST_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/vip_Entrust.html";
export const VIP_PROJECT_URL = process.env.VUE_APP_OLD_SEARCH_URL + "/vipProject.html";
export const VIP_BUSINESS_OPPORTUNITIES_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/vip_BusinessOpportunities.html";
export const VIP_RECOMMEND_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/vip_Recommend.html";
export const VIP_COLLECTION_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/vip_Collection.html";

// 交易中心
export const TRADE_CENTER_URL = "/trade-center";
export const TRADE_CENTER_SERVICE_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/tradeCenter_Service.html";
export const TRADE_CENTER_PAYMENT_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/tradeCenter_Payment.html";
export const TRADE_CENTER_INVOICE_MANAGE_URL = "/trade-center/invoice-manage";
export const TRADE_CENTER_ORDER_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/tradeCenter_Order.html";

// 账户管理
export const ACCOUNT_MANAGE_URL = "/account-manage";
export const ACCOUNT_MANAGE_ACCOUNT_INFO_URL = "/account-manage/account-info";
export const ACCOUNT_MANAGE_UPDATE_PASSWORD_URL = "/account-manage/modify-password";
export const ACCOUNT_MANAGE_ACCOUNT_SECURITY_URL = "/account-manage/account-security";

// 千里马学院
export const QLM_MBA_URL = "//mba.qianlima.com/";

// 企业管理
export const BUSINESS_MANAGE_SUB_ACCOUNT_MANAGE_UPDATE_USER_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subAccountManage_UpdateUser.html";
export const BUSINESS_MANAGE_SUB_ACCOUNT_CREATE_USER_URL =
  process.env.VUE_APP_OLD_USER_CENTER_URL + "/subAccountManage_CreateUser.html";

// 使用手册
export const PRODUCT_MANUAL = "/product-manual";

/** 企业监控 */
export const ENTERPRISE_MONITORING_URL = "/enterprise-monitoring";
/** 企业监控-企业动态 */
export const ENTERPRISE_MONITORING_DYNAMICS_URL = "/enterprise-monitoring/monitoring-dynamics";
/** 企业监控-企业列表 */
export const ENTERPRISE_MONITORING_LIST_URL = "/enterprise-monitoring/monitoring-list";
/** 企业监控-监控设置 */
export const ENTERPRISE_MONITORING_SETTINGS_URL = "/enterprise-monitoring/monitoring-settings";

/** 集成CRM落地页 */
export const INTEGRATION_CRM_URL = "/integration-crm";

export const MENU = [
  {
    id: "1",
    title: "首页",
    icon: "home",
    url: USER_CENTER_URL,
  },
  {
    id: "2",
    title: "找商机",
    icon: "search",
    children: [
      {
        id: "2-1",
        title: "采购意向",
        url: BUSINESS_OPPORTUNITY_PURCHASE_INTENTION_URL,
        tags: ["new"],
      },
      {
        id: "2-2",
        title: "标讯",
        url: BUSINESS_OPPORTUNITY_BIDDING_INFO_URL,
      },
      {
        id: "2-3",
        title: "拟在建项目",
        url: BUSINESS_OPPORTUNITY_CONSTR_PROJECT_URL,
      },
      {
        id: "2-4",
        title: "审批项目",
        url: BUSINESS_OPPORTUNITY_EXAMINE_PROJECT_URL,
      },
    ],
  },
  {
    id: "3",
    title: "订阅中心",
    icon: "order",
    children: [
      {
        id: "3-1",
        title: "新增订阅",
        children: [
          {
            id: "3-1-1",
            icon: "bidding-info",
            title: "新增标讯订阅",
            url: SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_BIDDING_INFO_URL,
          },
          {
            id: "3-1-4",
            icon: "purchase-intention",
            title: "新增采购意向订阅",
            url: SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_PURCHASE_INTENTION_URL,
          },
          {
            id: "3-1-2",
            icon: "constr-project",
            title: "新增拟在建订阅",
            url: SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_CONSTR_PROJECT_URL,
          },
          {
            id: "3-1-3",
            icon: "examine-project",
            title: "新增审批订阅",
            url: SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_EXAMINE_PROJECT_URL,
          },
        ],
      },
      {
        id: "3-2",
        title: "订阅信息",
        url: SUBSCRIBE_CENTER_SUBSCRIBE_INFO_URL,
        children: [
          {
            id: "3-2-1",
            title: "标讯订阅",
            icon: "bidding-info",
            children: [],
          },
          {
            id: "3-2-2",
            title: "拟在建订阅",
            icon: "constr-project",
            children: [],
          },
          {
            id: "3-2-3",
            title: "审批订阅",
            icon: "examine-project",
            children: [],
          },
        ],
      },

      {
        id: "3-3",
        title: "订阅管理",
        url: SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
      },
    ],
  },
  {
    id: "4",
    title: "我的关注",
    icon: "collect",
    children: [
      {
        id: "4-1",
        title: "我的收藏",
        url: MY_COLLECTION_URL,
      },
      {
        id: "4-2",
        title: "招标进度跟踪",
        url: MY_FOLLOW_BIDDING_URL,
      },
      {
        id: "4-3",
        title: "我的项目跟进",
        url: MY_FOLLOW_PROJECT_URL,
      },
      {
        id: "4-4",
        title: "我的项目联系人",
        url: MY_ACCOUNT_PROJECT_URL,
      },
      {
        id: "4-5",
        title: "我的浏览记录",
        url: MY_GET_BROWSES_URL,
      },
      {
        id: "4-6",
        title: "我的导出记录",
        url: MY_GET_EXPORT_URL,
      },
    ],
  },
  {
    id: "5",
    title: "VIP服务",
    icon: "vip",
    children: [
      {
        id: "5-1",
        title: "我的专属项目",
        url: VIP_MATCH_URL,
      },
      {
        id: "5-2",
        title: "业主委托项目",
        url: VIP_ENTRUST_URL,
      },
      {
        id: "5-3",
        title: "VIP项目",
        url: VIP_PROJECT_URL,
      },
      {
        id: "5-4",
        title: "精准商机",
        url: VIP_BUSINESS_OPPORTUNITIES_URL,
      },
      {
        id: "5-5",
        title: "申请推荐业主",
        url: VIP_RECOMMEND_URL,
      },
      {
        id: "5-6",
        title: "VIP信息收藏",
        url: VIP_COLLECTION_URL,
      },
    ],
  },
  {
    id: "6",
    title: "全部应用",
    icon: "app",
    children: [], // 在 system.js => asyncBasicDataInit 里进行动态获取
  },
  {
    id: "7",
    title: "交易中心",
    icon: "trade",
    children: [
      {
        id: "7-1",
        title: "服务列表",
        url: TRADE_CENTER_SERVICE_URL,
      },
      {
        id: "7-2",
        title: "付款方式",
        url: TRADE_CENTER_PAYMENT_URL,
      },
      {
        id: "7-3",
        title: "发票管理",
        url: TRADE_CENTER_INVOICE_MANAGE_URL,
      },
      {
        id: "7-4",
        title: "我的订单",
        url: TRADE_CENTER_ORDER_URL,
      },
    ],
  },
  {
    id: "8",
    title: "企业管理",
    icon: "enterprise",
    children: [
      {
        id: "8-1",
        title: "账号活跃度总览",
        url: ENTERPRISE_ACCOUNT_MANAGE_TOTAL,
      },
      {
        id: "8-2",
        title: "子账号管理",
        url: ENTERPRISE_MANAGE_SUB_ACCOUNT,
      },
      {
        id: "8-3",
        title: "企业智能管理",
        url: ENTERPRISE_ACCOUNT_MANAGE_SMART_MANAGE,
      },
    ],
  },
  {
    id: "9",
    title: "账户管理",
    icon: "account",
    children: [
      {
        id: "9-1",
        title: "账号信息",
        url: ACCOUNT_MANAGE_ACCOUNT_INFO_URL,
      },
      {
        id: "9-2",
        title: "修改密码",
        url: ACCOUNT_MANAGE_UPDATE_PASSWORD_URL,
      },
      {
        id: "9-3",
        title: "账户安全",
        url: ACCOUNT_MANAGE_ACCOUNT_SECURITY_URL,
      },
    ],
  },
  {
    id: "10",
    title: "千里马学院",
    icon: "xueyuan",
    url: QLM_MBA_URL,
  },
];

/** 列表 - 路由跳转前确认 **/
export const ROUTE_LEAVE_CONFIRM = [
  /** 订阅中心 - 订阅信息 - 标讯 **/
  SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_BIDDING_INFO_URL,
  /** 订阅中心 - 订阅管理 - 标讯订阅器配置**/
  SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_BIDDING_INFO_URL,

  /** 订阅中心 - 订阅管理 - 采购订阅器配置**/
  SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_PURCHASE_INTENTION_URL,
  /** 订阅中心 - 订阅信息 - 采购意向 **/
  SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_PURCHASE_INTENTION_URL,
];
